import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  loadUsers: ['partner', 'params'],
  loadUsersSuccess: ['data'],
  getUser: ['partner', 'id'],
  addUser: ['partner', 'data'],
  updateUser: ['partner', 'id', 'data'],
  removeUser: ['partner', 'id'],
  resetUsers: []
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  loading: true,
  data: {}
});

const loadUsersSuccess = (state, action) => ({
  ...state,
  loading: false,
  data: action.data
});

const addUser = (state, action) => ({
  ...state,
  loading: true
});

const updateUser = (state, action) => ({
  ...state,
  loading: true
});

const removeUser = (state, action) => ({
  ...state,
  loading: true
});

const resetUsers = (state, action) => INITIAL_STATE;

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOAD_USERS]: resetUsers,
  [Types.LOAD_USERS_SUCCESS]: loadUsersSuccess,
  [Types.RESET_USERS]: resetUsers,
  [Types.ADD_USER]: addUser,
  [Types.UPDATE_USER]: updateUser,
  [Types.REMOVE_USER]: removeUser
});
